import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const AssetContainer = styled.div<{
    maxWidth?: number;
}>`
    height: 180px;
    border-width: 1px;
    border-style: solid;
    border-color: ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    background-color: ${colorsPalettes.carbon[0]};
    max-width: ${(props) => `${props.maxWidth}px`};
    min-width: 0;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
        border-color: ${colorsPalettes.carbon[200]};
        box-shadow: 0 3px 6px rgba(14, 30, 62, 0.08);
    }
`;
